const getAlert = state => {
    return state.alert;
};

export default {
    getAlert,
};
